<template>
  <div class="f-btn" @click="handleClick">
    <svg-icon :icon-class="icon" v-if="icon" :style="{fontSize:iconSize}"></svg-icon>
    <slot />
  </div>
</template>

<script>
  export default {
    name: "index",
    props: {
      icon: {
        type: String
      },
      iconSize: {
        type: Number,
        default () {
          return 16
        }
      }
    },
    methods: {
      handleClick() {
        this.$emit("click")
      }
    }
  }
</script>

<style lang="scss">
  .f-btn {

    margin-right: 0px;
    height: 32px;
    line-height: 18px;
    border-radius: 5px;
    font-size: 16px;
    padding: 6px 20px;
    font-family: PingFang HK;
    font-weight: 400;
    color: #004a98;
    background-color: #fff;
    border: 1px solid #004a98;
    text-align: center;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 1px 2px rgba(66, 205, 167, 0.5)
  }

  .f-btn:hover {
    font-family: PingFang HK;
    font-weight: 400;
    background: #004a98;
    color: rgba(255, 255, 255, 1);
  }
</style>
